(function () {
  'use strict';

  angular
    .module('app.settings', []);
})();
